import React, { useEffect, useState } from "react";
import { supabase } from "../../../supabaseClient";
import { sortFees } from "../../../utility/eventFees";
import {
  EVENT_FEES_LABEL,
  FEE_SPLIT_HELP,
  estimateEventsFrom,
  isPrizeFundFee,
  perBowlerFeeLabel,
  prizeFundEstimateLines,
} from "../../../utility/prizeFundEstimate";

const EventFeeAmountFields = ({
  amounts,
  onAmountChange,
  title = EVENT_FEES_LABEL,
  fees: feesProp,
  disabled = false,
  events = [],
}) => {
  const [fetchedFees, setFetchedFees] = useState([]);
  const fees = feesProp || fetchedFees;
  const estimateEvents = estimateEventsFrom(events);

  useEffect(() => {
    if (feesProp) return undefined;
    let cancelled = false;
    supabase
      .from("fees")
      .select("id, feeName")
      .order("feeName")
      .then(({ data, error }) => {
        if (cancelled || error) return;
        setFetchedFees(sortFees(data || []));
      });
    return () => {
      cancelled = true;
    };
  }, [feesProp]);

  if (fees.length === 0) return null;

  return (
    <div>
      {title ? <h3 className="heading-display text-lg mb-1">{title}</h3> : null}
      <p className="text-sm font-medium text-brand-charcoal mb-3">
        {FEE_SPLIT_HELP}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fees.map((fee) => {
          const prizeFund = isPrizeFundFee(fee.feeName);
          const helpId = `event-fee-${fee.id}-help`;
          const lines = prizeFund
            ? prizeFundEstimateLines(amounts[fee.id], estimateEvents)
            : [];
          return (
            <div key={fee.id} className={prizeFund ? "md:col-span-2" : undefined}>
              <label
                htmlFor={`event-fee-${fee.id}`}
                className="block text-sm font-medium text-brand-charcoal mb-1"
              >
                {perBowlerFeeLabel(fee.feeName)}
              </label>
              <div className="relative">
                <span className="absolute left-3 top-2 text-brand-muted">$</span>
                <input
                  id={`event-fee-${fee.id}`}
                  type="number"
                  min="0"
                  step="0.01"
                  value={amounts[fee.id] || ""}
                  onChange={(e) => onAmountChange(fee.id, e.target.value)}
                  disabled={disabled}
                  aria-describedby={prizeFund ? helpId : undefined}
                  className="w-full pl-8 pr-3 py-2 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink disabled:bg-brand-cream disabled:cursor-not-allowed"
                  placeholder="0.00"
                />
              </div>
              {prizeFund ? (
                <div id={helpId} className="mt-2 space-y-1">
                  <p className="text-sm font-medium text-brand-charcoal">
                    Per bowler, not the total board.
                  </p>
                  {lines.length > 0 ? (
                    <div className="rounded-lg bg-brand-cream px-3 py-2 text-sm text-brand-charcoal">
                      {lines.map((line) => (
                        <p key={line}>{line}</p>
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { filledEventFees } from "../../../utility/eventFees";
export default EventFeeAmountFields;
